
export default async (context, inject) => {
    if(process.browser) {
        const sse = new EventSource(`/api/gateway._sse_?channel=broadcast`);

        const THROTTLE_MS = 300;
        const TERMINAL_STAGES = new Set(['START', 'FINISHED', 'ERROR']);

        const pending = new Map();
        let timer = null;

        const flush = () => {
            timer = null;

            if (pending.size === 0) {
                return;
            }

            const events = Array.from(pending.values());
            pending.clear();

            for (const event of events) {
                context.store.commit('SET_META', event);
            }
        };

        sse.addEventListener(`${context.$config.namespace}:broadcast:event`, (e) => {
            const data = JSON.parse(e.data);

            pending.set(data.file_id, data);

            if (TERMINAL_STAGES.has(data.stage)) {
                if (timer) {
                    clearTimeout(timer);
                }
                flush();
                return;
            }

            if (!timer) {
                timer = setTimeout(flush, THROTTLE_MS);
            }
        });

        context.$sse = {};

        inject('sse', {});
    }
}
